import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { DateField } from "@/components/DateField";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, errMsg, money } from "@/lib/api";

// target: { annee, trimestre, tps, tvq }
export const DeclareDialog = ({ target, onClose, onDone }) => {
  const [form, setForm] = useState({ date_declaration: "", tps: 0, tvq: 0, note: "" });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (target) setForm({ date_declaration: new Date().toISOString().slice(0, 10), tps: target.tps, tvq: target.tvq, note: "" });
  }, [target]);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/declarations", { annee: target.annee, trimestre: target.trimestre, ...form, tps: Number(form.tps) || 0, tvq: Number(form.tvq) || 0 });
      toast.success(`T${target.trimestre} ${target.annee} marqué comme déclaré`);
      onDone();
    } catch (err) { toast.error(errMsg(err)); } finally { setLoading(false); }
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      {target && (
        <DialogContent className="max-w-md" data-testid="declare-dialog">
          <DialogHeader>
            <DialogTitle>Marquer T{target.trimestre} {target.annee} comme déclaré</DialogTitle>
            <DialogDescription>Le rappel passera ensuite au trimestre suivant.</DialogDescription>
          </DialogHeader>
          <form onSubmit={submit} className="grid grid-cols-2 gap-3">
            <div className="col-span-2 space-y-1"><Label>Date de la déclaration</Label>
              <DateField required value={form.date_declaration} onChange={(v) => setForm({ ...form, date_declaration: v })} className="w-full" data-testid="declare-date-input" /></div>
            <div className="space-y-1"><Label>TPS déclarée ($)</Label>
              <Input type="number" step="0.01" min="0" value={form.tps} onChange={set("tps")} data-testid="declare-tps-input" /></div>
            <div className="space-y-1"><Label>TVQ déclarée ($)</Label>
              <Input type="number" step="0.01" min="0" value={form.tvq} onChange={set("tvq")} data-testid="declare-tvq-input" /></div>
            <p className="col-span-2 text-sm">Total : <b className="tabular" data-testid="declare-total">{money((Number(form.tps) || 0) + (Number(form.tvq) || 0))}</b></p>
            <div className="col-span-2 space-y-1"><Label>Note (optionnel)</Label>
              <Textarea rows={2} value={form.note} onChange={set("note")} placeholder="N° de confirmation Revenu Québec…" data-testid="declare-note-input" /></div>
            <DialogFooter className="col-span-2">
              <Button type="submit" disabled={loading} className="bg-emerald-700 hover:bg-emerald-800" data-testid="declare-submit-button">
                {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Enregistrer
              </Button>
            </DialogFooter>
          </form>
        </DialogContent>
      )}
    </Dialog>
  );
};
